// Comprehensive i18n service

export type LangCode = 'en' | 'ru' | 'es' | 'de' | 'fr' | 'pt' | 'zh' | 'ja' | 'ko' | 'ar' | 'it' | 'pl' | 'tr' | 'vi' | 'nl' | 'id' | 'lt';

const translations: Record<string, Record<string, string>> = {
  en: {
    // NAV & GLOBAL
    nav_home: "Main",
    nav_market: "Market",
    nav_staff: "Staff Access",
    
    // FOOTER
    footer_desc: "The premier marketplace for elite OnlyFans management agencies. Automate your workflow with enterprise-grade AI tools.",
    footer_support: "Support",
    footer_contact: "Contact Us",
    footer_connection: "Connection",
    footer_channel_btn: "Telegram Channel",
    footer_rights: "All Rights Reserved.",

    // HERO
    hero_title_top: "BEST WORKFLOWS",
    hero_title_bottom: "FOR COMFYUI",
    hero_title_2: "Gen NSFW Photo + Video, TikTok Dance, Lipsync",
    hero_btn_shop: "Open Shop",
    hero_btn_contact: "Contact Us",
    
    // PAIN / SOLUTION
    pain_title: "INEFFICIENCY IS COSTING YOU",
    pain_box_title_1: "Problem",
    pain_p_1: "Chaotic workflows",
    pain_p_2: "Low quality",
    pain_p_3: "Low views → Low income",
    pain_p_4: "Unrealistic photos & videos",
    pain_box_title_2: "OFM HUB",
    pain_s_1: "Realistic NSFW Photos",
    pain_s_2: "High-quality dance videos",
    pain_s_3: "Precision Face Lip-sync",
    pain_s_4: "Videos up to 1-2 minutes",
    pain_s_5: "Low artifacts",
    
    // FEATURED & PROOF
    feat_title: "TOP SELLING ASSETS",
    btn_to_shop: "View Asset",
    view_all_assets: "View All Assets",
    proof_stat_1: "Clients",
    proof_stat_2: "Revenue Growth",
    proof_stat_3: "Rating",
    
    // CTA
    cta_title: "Start Earning More Now",
    cta_text: "Select your pack in the shop or contact us for personal setup.",
    cta_btn_tg: "Telegram Support",

    // SHOP MAIN
    shop_header: "Marketplace",
    filter_all: "All Categories",
    search_placeholder: "SEARCH ARTIFACTS...",
    nsfw_mode: "18+ MODE",
    reset_system: "Reset System",
    no_signals: "NO SIGNALS FOUND",
    no_signals_sub: "Adjust your filters or search query",
    sale_tag: "SALE",
    add_btn: "Add",

    // PRODUCT MODAL
    prod_breadcrumb: "Marketplace",
    prod_discount_active: "Discount Active",
    prod_sys_desc: "System Description",
    prod_tech_specs: "Technical Specs",
    prod_secure: "Secure 256-bit",
    prod_instant: "Instant Access",
    prod_add_cart: "Add to Cart",
    prod_save: "Save",

    // CART DRAWER
    cart_title: "CART",
    cart_encrypted: "Encrypted Connection",
    cart_empty_title: "No Assets Selected",
    cart_empty_text: "Cart Empty",
    cart_select_asset: "Select Payment Asset",
    cart_subtotal: "Subtotal",
    cart_discounts: "Discounts",
    cart_net_fee: "Network Fee",
    cart_calc_wallet: "calc. in wallet",
    cart_total_due: "TOTAL DUE",
    cart_proceed: "Proceed to Pay",
    cart_secured_by: "Secured by CryptoBot",
    
    // PAYMENT MODAL (UPDATED)
    pay_protocol: "Secure Payment Protocol",
    pay_redirect: "You are initiating a secure transaction via CryptoBot. Follow the steps below precisely.",
    pay_step_1: "Initiate Transfer",
    pay_step_1_desc: "Click the button below to open the secure bot invoice.",
    pay_step_2: "Confirm Payment",
    pay_step_2_desc: "Send the exact amount of {asset}. Wait for blockchain confirmation.",
    pay_step_3: "Return to Hub",
    pay_step_3_desc: "CRITICAL: Tap 'Return to Merchant' in Telegram to unlock your files.",
    pay_btn_open: "Launch CryptoBot Gateway",
    pay_status_connect: "Establishing Secure Handshake...",
    pay_status_redirect: "Redirecting to Payment Node...",
    
    // SUCCESS & DOWNLOAD (NEW)
    success_title: "Transaction Verified",
    success_subtitle: "Your digital assets have been decoupled from the blockchain.",
    success_expires: "LINK EXPIRATION",
    success_download: "Download Asset",
    success_password: "Access Key / Note",
    success_expired_title: "Link Expired",
    success_expired_desc: "For security reasons, download links expire after 1 hour. Please contact support if you missed your window.",
    success_close: "Close Vault",

    // MANUAL PAYMENT
    pay_manual_title: "Connection Failed",
    pay_manual_desc: "The automated gateway is blocked by your browser/provider. Use manual checkout to complete your order instantly.",
    pay_manual_btn: "Contact Manager",

    // ADMIN AUTH
    admin_auth_title: "SYSTEM ACCESS",
    admin_auth_sub: "AUTHORIZED PERSONNEL ONLY",
    admin_placeholder_key: "ENCRYPTED KEY",
    admin_btn_auth: "Authenticate",
    admin_err_invalid: "Invalid Credentials",

    // ADMIN DASHBOARD
    admin_dash_overview: "Overview",
    admin_dash_inventory: "Inventory",
    admin_dash_cms: "CMS / Editorial",
    admin_dash_logout: "Logout",
    admin_view_site: "View Live Site",
    admin_proj_rev: "Projected Revenue",
    admin_active_art: "Active Artifacts",
    
    // ADMIN FINANCE
    admin_fin_revenue: "Total Revenue",
    admin_fin_orders: "Total Orders",
    admin_fin_avg: "Avg. Order",
    admin_fin_pending: "Pending Invoices",
    admin_fin_chart: "Revenue (7 Days)",
    admin_fin_trans: "Transactions",
    admin_fin_verify: "Verify",
    admin_fin_refresh: "Refresh Data",
    
    // ADMIN INVENTORY
    admin_total_items: "Total Items",
    admin_create_new: "Create New",
    admin_th_item: "Item",
    admin_th_value: "Value",
    admin_th_controls: "Controls",
    
    // ADMIN EDITOR
    admin_edit_artifact: "Edit Artifact",
    admin_grp_title: "Title",
    admin_grp_desc: "Description",
    admin_grp_cover: "Cover Image URL",
    admin_grp_gallery: "Gallery",
    admin_grp_video: "Preview Video URL (Optional)",
    admin_grp_delivery: "Digital Delivery",
    admin_grp_access: "Access Instructions",
    admin_grp_pricing: "Pricing Model",
    admin_lbl_current: "Current Price",
    admin_lbl_old: "Original Price (Strike-through)",
    admin_lbl_tech: "Technical Specs",
    admin_lbl_tags: "Tags",
    admin_btn_cancel: "Cancel",
    admin_btn_save: "Save Artifact",

    // ADMIN CMS
    admin_cms_hero: "Hero Videos",
    admin_cms_add_slide: "Add Slide",
    admin_cms_showcase: "Homepage Showcase (Top Selling)",
    admin_cms_save: "Save Configuration",
    admin_cms_title_lbl: "Slide Title",
    admin_cms_url_lbl: "Media URL",
    admin_cms_delay_lbl: "Anim. Delay",
    admin_cms_nsfw_on: "18+ ON",
    admin_cms_nsfw_off: "SAFE",
    admin_cms_type_vid: "Video",
    admin_cms_type_img: "Image",
    admin_cms_active_list: "Active & Ordered",
    admin_cms_avail_list: "Available Library",
    admin_cms_drag_hint: "Drag items to reorder in real-time",

    // ADMIN FINANCE — Orders & Transactions
    admin_fin_create_order: "Create Order",
    admin_fin_edit_order: "Edit Order",
    admin_fin_invoice_id: "Invoice ID",
    admin_fin_status: "Status",
    admin_fin_status_admin: "Admin (created manually)",
    admin_fin_status_cryptobot: "CryptoBot (confirmed)",
    admin_fin_status_pending: "Pending",
    admin_fin_status_expired: "Expired",
    admin_fin_add_product: "Add Product",
    admin_fin_select_product: "Select product...",
    admin_fin_items: "Items",
    admin_fin_no_items: "No items",
    admin_fin_total: "Total",
    admin_fin_filter_all: "All",
    admin_fin_filter_admin: "Admin",
    admin_fin_filter_cryptobot: "CryptoBot",
    admin_fin_filter_pending: "Pending",
    admin_fin_filter_expired: "Expired",
    admin_fin_cryptobot_btn: "CryptoBot ✓",
    admin_fin_no_transactions: "No transactions found",
    admin_fin_search_placeholder: "Search invoice ID...",
    admin_fin_date_id: "Date / ID",
    admin_fin_realtime: "Real-time Data",
    admin_fin_save: "Save",

    // ADMIN LANDING
    admin_landing_title: "Landing Page Content",
    admin_landing_desc: "Edit blocks: Pain/Solution, metrics, and CTA",
    admin_landing_block1: "Block «Problem / Solution»",
    admin_landing_block1_title: "Block title",
    admin_landing_block1_problem: "«Problem» title",
    admin_landing_block1_problems: "Problem items (one per line)",
    admin_landing_block1_solution: "«Solution» title",
    admin_landing_block1_solutions: "Solution items (one per line)",
    admin_landing_block2: "Metrics (500+, +280%, 4.9/5)",
    admin_landing_block2_highlight: "Highlight",
    admin_landing_block3: "Block «Start Earning More»",
    admin_landing_block3_title: "Title",
    admin_landing_block3_text: "Text under title",
    admin_landing_block3_btn: "Telegram button text",
    admin_landing_block3_url: "Button link (URL)",
    admin_hero_block_title: "Hero Block (Main Header)",
    admin_hero_block_desc: "Edit main page title and buttons — changes visible immediately",
    admin_hero_title_top: "Title line 1",
    admin_hero_title_bottom: "Title line 2",
    admin_hero_subtitle: "Subtitle",
    admin_hero_shop_btn: "Shop button text",
    admin_hero_contact_btn: "Contact button text",
    admin_hero_contact_url: "Contact button link (URL)",

    // MARKDOWN EDITOR
    md_bold: "Bold",
    md_italic: "Italic",
    md_code: "Code",
    md_header: "Header",
    md_list: "List",
    md_quote: "Quote",
    md_link: "Link",
    md_color: "Color",
    md_preview: "Preview",
    md_edit: "Edit",
    md_split: "Split View",
    md_placeholder: "Type description here... Select text and right-click for options.",
    md_chars: "chars",
    md_ctx_format: "Formatting",
    md_ctx_headers: "Structure",
    md_ctx_color: "Color Highlight",
  },
  ru: {
    // NAV & GLOBAL
    nav_home: "Главная",
    nav_market: "Магазин",
    nav_staff: "Служебный вход",

    // FOOTER
    footer_desc: "Ведущий маркетплейс для элитных OnlyFans агентств. Автоматизируйте рабочий процесс с помощью ИИ-инструментов корпоративного уровня.",
    footer_support: "Поддержка",
    footer_contact: "Связаться с нами",
    footer_connection: "Связь",
    footer_channel_btn: "Telegram Канал",
    footer_rights: "Все права защищены.",

    // HERO
    hero_title_top: "ЛУЧШИЕ WORKFLOW",
    hero_title_bottom: "ДЛЯ COMFYUI",
    hero_title_2: "Генерация NSFW фото + видео, танцы для TikTok/Instagram, липсинк-анимации",
    hero_btn_shop: "В магазин",
    hero_btn_contact: "Связаться",
    
    // PAIN / SOLUTION
    pain_title: "ВЫ ТЕРЯЕТЕ ДЕНЬГИ НА РУТИНЕ",
    pain_box_title_1: "Проблема",
    pain_p_1: "Хаотичные процессы",
    pain_p_2: "Низкое качество",
    pain_p_3: "Мало просмотров → мало денег",
    pain_p_4: "Нереалистичный контент",
    pain_box_title_2: "OFM HUB",
    pain_s_1: "Реалистичные NSFW-фото",
    pain_s_2: "Вирусные видео танцев",
    pain_s_3: "Точный липсинк (губы)",
    pain_s_4: "Видео до 2 минут",
    pain_s_5: "Минимум артефактов",
    
    // FEATURED & PROOF
    feat_title: "ХИТЫ ПРОДАЖ",
    btn_to_shop: "Смотреть",
    view_all_assets: "Весь каталог",
    proof_stat_1: "Клиентов",
    proof_stat_2: "Рост выручки",
    proof_stat_3: "Рейтинг",
    
    // CTA
    cta_title: "Начни зарабатывать больше",
    cta_text: "Выберите пак в магазине или напишите нам для персональной настройки под ваш трафик.",
    cta_btn_tg: "Поддержка в Telegram",

    // SHOP MAIN
    shop_header: "Маркетплейс",
    filter_all: "Все категории",
    search_placeholder: "ПОИСК АРТЕФАКТОВ...",
    nsfw_mode: "18+ РЕЖИМ",
    reset_system: "Сброс системы",
    no_signals: "СИГНАЛ НЕ НАЙДЕН",
    no_signals_sub: "Измените фильтры или поисковый запрос",
    sale_tag: "СКИДКА",
    add_btn: "В корзину",

    // PRODUCT MODAL
    prod_breadcrumb: "Каталог",
    prod_discount_active: "Акция активна",
    prod_sys_desc: "Системное описание",
    prod_tech_specs: "Технические данные",
    prod_secure: "Защита 256-bit",
    prod_instant: "Моментальный доступ",
    prod_add_cart: "Добавить в корзину",
    prod_save: "Экономия",

    // CART DRAWER
    cart_title: "КОРЗИНА",
    cart_encrypted: "Зашифрованное соединение",
    cart_empty_title: "Активы не выбраны",
    cart_empty_text: "Корзина пуста",
    cart_select_asset: "Выберите валюту оплаты",
    cart_subtotal: "Подытог",
    cart_discounts: "Скидки",
    cart_net_fee: "Комиссия сети",
    cart_calc_wallet: "расч. в кошельке",
    cart_total_due: "К ОПЛАТЕ",
    cart_proceed: "Перейти к оплате",
    cart_secured_by: "Безопасность через CryptoBot",
    
    // PAYMENT MODAL (UPDATED)
    pay_protocol: "Протокол Оплаты",
    pay_redirect: "Вы инициируете защищенную транзакцию через CryptoBot. Строго следуйте инструкциям.",
    pay_step_1: "Начать перевод",
    pay_step_1_desc: "Нажмите кнопку ниже, чтобы открыть счет в боте.",
    pay_step_2: "Подтвердить оплату",
    pay_step_2_desc: "Отправьте точную сумму в {asset}. Дождитесь подтверждения блокчейна.",
    pay_step_3: "Вернуться в Hub",
    pay_step_3_desc: "ВАЖНО: Нажмите 'Return to Merchant' (Вернуться в магазин) в Telegram, чтобы получить файлы.",
    pay_btn_open: "Открыть Шлюз CryptoBot",
    pay_status_connect: "Установка соединения...",
    pay_status_redirect: "Переход к оплате...",

    // SUCCESS & DOWNLOAD (NEW)
    success_title: "Транзакция Подтверждена",
    success_subtitle: "Ваши цифровые активы были извлечены из блокчейна.",
    success_expires: "ИСТЕЧЕНИЕ ССЫЛКИ",
    success_download: "Скачать Файл",
    success_password: "Пароль / Заметка",
    success_expired_title: "Ссылка Истекла",
    success_expired_desc: "В целях безопасности ссылки на скачивание действуют 1 час. Если вы не успели, напишите в поддержку.",
    success_close: "Закрыть Хранилище",

    // MANUAL PAYMENT
    pay_manual_title: "Ошибка соединения",
    pay_manual_desc: "Автоматический шлюз заблокирован вашим провайдером. Используйте ручную оплату через менеджера.",
    pay_manual_btn: "Написать Менеджеру",

    // ADMIN AUTH
    admin_auth_title: "ДОСТУП К СИСТЕМЕ",
    admin_auth_sub: "ТОЛЬКО ДЛЯ ПЕРСОНАЛА",
    admin_placeholder_key: "КЛЮЧ ШИФРОВАНИЯ",
    admin_btn_auth: "Войти",
    admin_err_invalid: "Неверные учетные данные",

    // ADMIN DASHBOARD
    admin_dash_overview: "Обзор",
    admin_dash_inventory: "Инвентарь",
    admin_dash_cms: "CMS / Редактор",
    admin_dash_logout: "Выйти",
    admin_view_site: "На сайт",
    admin_proj_rev: "Прогноз выручки",
    admin_active_art: "Активные лоты",
    
    // ADMIN FINANCE
    admin_fin_revenue: "Общая выручка",
    admin_fin_orders: "Заказы",
    admin_fin_avg: "Ср. чек",
    admin_fin_pending: "Ожидают оплаты",
    admin_fin_chart: "Выручка (7 дней)",
    admin_fin_trans: "Транзакции",
    admin_fin_verify: "Проверить",
    admin_fin_refresh: "Обновить данные",
    
    // ADMIN INVENTORY
    admin_total_items: "Всего лотов",
    admin_create_new: "Создать новый",
    admin_th_item: "Товар",
    admin_th_value: "Стоимость",
    admin_th_controls: "Управление",
    
    // ADMIN EDITOR
    admin_edit_artifact: "Редактор артефакта",
    admin_grp_title: "Название",
    admin_grp_desc: "Описание",
    admin_grp_cover: "URL Обложки",
    admin_grp_gallery: "Галерея",
    admin_grp_video: "URL Превью видео (опционально)",
    admin_grp_delivery: "Цифровая доставка",
    admin_grp_access: "Инструкции доступа",
    admin_grp_pricing: "Модель ценообразования",
    admin_lbl_current: "Текущая цена",
    admin_lbl_old: "Старая цена (зачеркнутая)",
    admin_lbl_tech: "Тех. характеристики",
    admin_lbl_tags: "Теги",
    admin_btn_cancel: "Отмена",
    admin_btn_save: "Сохранить",

    // ADMIN CMS
    admin_cms_hero: "Видео на главном (Hero)",
    admin_cms_add_slide: "Добавить слайд",
    admin_cms_showcase: "Витрина (Хиты продаж)",
    admin_cms_save: "Сохранить конфигурацию",
    admin_cms_title_lbl: "Название слайда",
    admin_cms_url_lbl: "URL Медиа",
    admin_cms_delay_lbl: "Задержка (сек)",
    admin_cms_nsfw_on: "18+ ВКЛ",
    admin_cms_nsfw_off: "БЕЗОПАСНО",
    admin_cms_type_vid: "Видео",
    admin_cms_type_img: "Фото",
    admin_cms_active_list: "Активные и Отсортированные",
    admin_cms_avail_list: "Библиотека Товаров",
    admin_cms_drag_hint: "Перетаскивайте для смены порядка",

    // ADMIN FINANCE — Orders & Transactions
    admin_fin_create_order: "Создать заказ",
    admin_fin_edit_order: "Редактировать заказ",
    admin_fin_invoice_id: "ID счёта",
    admin_fin_status: "Статус",
    admin_fin_status_admin: "Админ (создан вручную)",
    admin_fin_status_cryptobot: "CryptoBot (подтверждён)",
    admin_fin_status_pending: "Ожидает",
    admin_fin_status_expired: "Истёк",
    admin_fin_add_product: "Добавить товар",
    admin_fin_select_product: "Выберите товар...",
    admin_fin_items: "Товары",
    admin_fin_no_items: "Нет товаров",
    admin_fin_total: "Итого",
    admin_fin_filter_all: "Все",
    admin_fin_filter_admin: "Админ",
    admin_fin_filter_cryptobot: "CryptoBot",
    admin_fin_filter_pending: "Ожидает",
    admin_fin_filter_expired: "Истёк",
    admin_fin_cryptobot_btn: "CryptoBot ✓",
    admin_fin_no_transactions: "Транзакции не найдены",
    admin_fin_search_placeholder: "Поиск по ID счёта...",
    admin_fin_date_id: "Дата / ID",
    admin_fin_realtime: "Данные в реальном времени",
    admin_fin_save: "Сохранить",

    // ADMIN LANDING
    admin_landing_title: "Контент главной страницы",
    admin_landing_desc: "Редактируйте блоки: «Вы теряете деньги», метрики и CTA",
    admin_landing_block1: "Блок «Проблема / Решение»",
    admin_landing_block1_title: "Заголовок блока",
    admin_landing_block1_problem: "Заголовок «Проблема»",
    admin_landing_block1_problems: "Пункты проблемы (каждый с новой строки)",
    admin_landing_block1_solution: "Заголовок «Решение»",
    admin_landing_block1_solutions: "Пункты решения (каждый с новой строки)",
    admin_landing_block2: "Метрики (500+, +280%, 4.9/5)",
    admin_landing_block2_highlight: "Выделить",
    admin_landing_block3: "Блок «Начни зарабатывать больше»",
    admin_landing_block3_title: "Заголовок",
    admin_landing_block3_text: "Текст под заголовком",
    admin_landing_block3_btn: "Текст кнопки Telegram",
    admin_landing_block3_url: "Ссылка кнопки (URL)",
    admin_hero_block_title: "Hero блок (главный заголовок)",
    admin_hero_block_desc: "Редактируйте заголовок и кнопки — изменения видны сразу",
    admin_hero_title_top: "Строка заголовка 1",
    admin_hero_title_bottom: "Строка заголовка 2",
    admin_hero_subtitle: "Подзаголовок",
    admin_hero_shop_btn: "Текст кнопки магазина",
    admin_hero_contact_btn: "Текст кнопки связи",
    admin_hero_contact_url: "Ссылка кнопки связи (URL)",

    // MARKDOWN EDITOR
    md_bold: "Жирный",
    md_italic: "Курсив",
    md_code: "Код",
    md_header: "Заголовок",
    md_list: "Список",
    md_quote: "Цитата",
    md_link: "Ссылка",
    md_color: "Цвет",
    md_preview: "Просмотр",
    md_edit: "Редактор",
    md_split: "2 Окна",
    md_placeholder: "Введите описание... Выделите текст и нажмите ПКМ для меню.",
    md_chars: "симв.",
    md_ctx_format: "Форматирование",
    md_ctx_headers: "Структура",
    md_ctx_color: "Выделение цветом",
  },
  // Fallback to 'en' for: es, de, fr, pt, zh, ja, ko, ar, it, pl, tr, vi, nl, id
  es: {}, de: {}, fr: {}, pt: {}, zh: {}, ja: {}, ko: {}, ar: {}, it: {}, pl: {}, tr: {}, vi: {}, nl: {}, id: {},
  lt: {
    // NAV & GLOBAL
    nav_home: "Pagrindinis",
    nav_market: "Parduotuvė",
    nav_staff: "Personalo prieiga",

    // FOOTER
    footer_desc: "Pirmaujanti OnlyFans valdymo agentūrų rinka. Automatizuokite darbo eigą su AI įrankiais.",
    footer_support: "Pagalba",
    footer_contact: "Susisiekite",
    footer_connection: "Ryšys",
    footer_channel_btn: "Telegram kanalas",
    footer_rights: "Visos teisės saugomos.",

    // HERO
    hero_title_top: "GERIAUSI WORKFLOW",
    hero_title_bottom: "COMFYUI PLATFORMAI",
    hero_title_2: "NSFW nuotraukos ir vaizdo įrašai, TikTok šokiai, lipsync animacijos",
    hero_btn_shop: "Atidaryti parduotuvę",
    hero_btn_contact: "Susisiekti",

    // PAIN / SOLUTION
    pain_title: "NEEFEKTYVUMAS KAINUOJA JUMS PINIGUS",
    pain_box_title_1: "Problema",
    pain_p_1: "Chaotiški procesai",
    pain_p_2: "Žema kokybė",
    pain_p_3: "Mažai peržiūrų → mažos pajamos",
    pain_p_4: "Nerealūs vaizdai",
    pain_box_title_2: "OFM HUB",
    pain_s_1: "Realistiškos NSFW nuotraukos",
    pain_s_2: "Aukštos kokybės šokio vaizdo įrašai",
    pain_s_3: "Tikslus lūpų sinchronizavimas",
    pain_s_4: "Vaizdo įrašai iki 2 minučių",
    pain_s_5: "Minimalūs artefaktai",

    // FEATURED & PROOF
    feat_title: "GERIAUSIAI PARDUODAMI PRODUKTAI",
    btn_to_shop: "Peržiūrėti",
    view_all_assets: "Visi produktai",
    proof_stat_1: "Klientų",
    proof_stat_2: "Pajamų augimas",
    proof_stat_3: "Įvertinimas",

    // CTA
    cta_title: "Pradėkite uždirbti daugiau",
    cta_text: "Pasirinkite paketą parduotuvėje arba susisiekite su mumis dėl asmeninės sąrankos.",
    cta_btn_tg: "Telegram palaikymas",

    // SHOP MAIN
    shop_header: "Prekyvietė",
    filter_all: "Visos kategorijos",
    search_placeholder: "IEŠKOTI PRODUKTŲ...",
    nsfw_mode: "18+ REŽIMAS",
    reset_system: "Atstatyti sistemą",
    no_signals: "PRODUKTŲ NERASTA",
    no_signals_sub: "Pakeiskite filtrus arba paieškos užklausą",
    sale_tag: "IŠPARDAVIMAS",
    add_btn: "Pridėti",

    // PRODUCT MODAL
    prod_breadcrumb: "Prekyvietė",
    prod_discount_active: "Nuolaida aktyvuota",
    prod_sys_desc: "Sistemos aprašymas",
    prod_tech_specs: "Techninės specifikacijos",
    prod_secure: "256 bitų apsauga",
    prod_instant: "Momentinė prieiga",
    prod_add_cart: "Pridėti į krepšelį",
    prod_save: "Sutaupyti",

    // CART DRAWER
    cart_title: "KREPŠELIS",
    cart_encrypted: "Šifruotas ryšys",
    cart_empty_title: "Produktų nepasirinkta",
    cart_empty_text: "Krepšelis tuščias",
    cart_select_asset: "Pasirinkite mokėjimo valiutą",
    cart_subtotal: "Tarpinė suma",
    cart_discounts: "Nuolaidos",
    cart_net_fee: "Tinklo mokestis",
    cart_calc_wallet: "skaičiuojama piniginėje",
    cart_total_due: "IŠ VISO MOKĖTI",
    cart_proceed: "Pereiti prie mokėjimo",
    cart_secured_by: "Apsaugota CryptoBot",

    // PAYMENT MODAL
    pay_protocol: "Saugaus mokėjimo protokolas",
    pay_redirect: "Jūs inicijuojate saugų sandorį per CryptoBot. Tiksliai vadovaukitės instrukcijomis.",
    pay_step_1: "Inicijuoti pervedimą",
    pay_step_1_desc: "Spustelėkite mygtuką žemiau, kad atidarytumėte saugią sąskaitą.",
    pay_step_2: "Patvirtinti mokėjimą",
    pay_step_2_desc: "Siųskite tikslią sumą {asset}. Palaukite blokų grandinės patvirtinimo.",
    pay_step_3: "Grįžti į Hub",
    pay_step_3_desc: "SVARBU: Telegram paspauskite Return to Merchant (grįžti į pardavėją), kad atrakintumėte failus.",
    pay_btn_open: "Paleisti CryptoBot šliuzą",
    pay_status_connect: "Nustatomas saugus ryšys...",
    pay_status_redirect: "Nukreipiama į mokėjimo mazgą...",

    // SUCCESS & DOWNLOAD
    success_title: "Sandoris patvirtintas",
    success_subtitle: "Jūsų skaitmeniniai ištekliai buvo sėkmingai gauti.",
    success_expires: "NUORODOS GALIOJIMAS",
    success_download: "Atsisiųsti failą",
    success_password: "Prieigos raktas / Pastaba",
    success_expired_title: "Nuoroda nebegalioja",
    success_expired_desc: "Saugumo sumetimais atsisiuntimo nuorodos galioja 1 valandą. Susisiekite su palaikymu, jei praleidote laiką.",
    success_close: "Uždaryti saugyklą",

    // MANUAL PAYMENT
    pay_manual_title: "Ryšio klaida",
    pay_manual_desc: "Automatinis šliuzas užblokuotas jūsų naršyklės/tiekėjo. Naudokite rankinį mokėjimą.",
    pay_manual_btn: "Susisiekti su vadybininku",

    // ADMIN AUTH
    admin_auth_title: "SISTEMOS PRIEIGA",
    admin_auth_sub: "TIK ĮGALIOTAM PERSONALUI",
    admin_placeholder_key: "ŠIFRUOTAS RAKTAS",
    admin_btn_auth: "Prisijungti",
    admin_err_invalid: "Neteisingi prisijungimo duomenys",

    // ADMIN DASHBOARD
    admin_dash_overview: "Apžvalga",
    admin_dash_inventory: "Inventorius",
    admin_dash_cms: "CMS / Redaktorius",
    admin_dash_logout: "Atsijungti",
    admin_view_site: "Peržiūrėti svetainę",
    admin_proj_rev: "Prognozuojamos pajamos",
    admin_active_art: "Aktyvūs produktai",

    // ADMIN FINANCE
    admin_fin_revenue: "Bendros pajamos",
    admin_fin_orders: "Užsakymai",
    admin_fin_avg: "Vidurkis",
    admin_fin_pending: "Laukiančios sąskaitos",
    admin_fin_chart: "Pajamos (7 dienos)",
    admin_fin_trans: "Sandoriai",
    admin_fin_verify: "Patikrinti",
    admin_fin_refresh: "Atnaujinti duomenis",

    // ADMIN INVENTORY
    admin_total_items: "Iš viso produktų",
    admin_create_new: "Sukurti naują",
    admin_th_item: "Produktas",
    admin_th_value: "Vertė",
    admin_th_controls: "Valdymas",

    // ADMIN EDITOR
    admin_edit_artifact: "Redaguoti produktą",
    admin_grp_title: "Pavadinimas",
    admin_grp_desc: "Aprašymas",
    admin_grp_cover: "Viršelio nuotraukos URL",
    admin_grp_gallery: "Galerija",
    admin_grp_video: "Peržiūros vaizdo URL (neprivaloma)",
    admin_grp_delivery: "Skaitmeninis pristatymas",
    admin_grp_access: "Prieigos instrukcijos",
    admin_grp_pricing: "Kainodara",
    admin_lbl_current: "Dabartinė kaina",
    admin_lbl_old: "Senoji kaina (perbraukta)",
    admin_lbl_tech: "Techninės specifikacijos",
    admin_lbl_tags: "Žymos",
    admin_btn_cancel: "Atšaukti",
    admin_btn_save: "Išsaugoti produktą",

    // ADMIN CMS
    admin_cms_hero: "Hero vaizdo įrašai",
    admin_cms_add_slide: "Pridėti skaidrę",
    admin_cms_showcase: "Pagrindinis puslapis (geriausiai parduodami)",
    admin_cms_save: "Išsaugoti konfigūraciją",
    admin_cms_title_lbl: "Skaidrės pavadinimas",
    admin_cms_url_lbl: "Medijos URL",
    admin_cms_delay_lbl: "Animacijos vėlinimas",
    admin_cms_nsfw_on: "18+ ĮJUNGTA",
    admin_cms_nsfw_off: "SAUGU",
    admin_cms_type_vid: "Vaizdo įrašas",
    admin_cms_type_img: "Nuotrauka",
    admin_cms_active_list: "Aktyvūs ir surūšiuoti",
    admin_cms_avail_list: "Biblioteka",
    admin_cms_drag_hint: "Vilkite elementus, kad pakeistumėte tvarką",

    // ADMIN FINANCE — Orders
    admin_fin_create_order: "Sukurti užsakymą",
    admin_fin_edit_order: "Redaguoti užsakymą",
    admin_fin_invoice_id: "Sąskaitos ID",
    admin_fin_status: "Būsena",
    admin_fin_status_admin: "Administratorius (sukurtas rankiniu būdu)",
    admin_fin_status_cryptobot: "CryptoBot (patvirtinta)",
    admin_fin_status_pending: "Laukiama",
    admin_fin_status_expired: "Pasibaigė",
    admin_fin_add_product: "Pridėti produktą",
    admin_fin_select_product: "Pasirinkite produktą...",
    admin_fin_items: "Produktai",
    admin_fin_no_items: "Produktų nėra",
    admin_fin_total: "Iš viso",
    admin_fin_filter_all: "Visi",
    admin_fin_filter_admin: "Administratorius",
    admin_fin_filter_cryptobot: "CryptoBot",
    admin_fin_filter_pending: "Laukiama",
    admin_fin_filter_expired: "Pasibaigė",
    admin_fin_cryptobot_btn: "CryptoBot ✓",
    admin_fin_no_transactions: "Sandorių nerasta",
    admin_fin_search_placeholder: "Ieškoti pagal sąskaitos ID...",
    admin_fin_date_id: "Data / ID",
    admin_fin_realtime: "Duomenys realiuoju laiku",
    admin_fin_save: "Išsaugoti",

    // ADMIN LANDING
    admin_landing_title: "Pagrindinio puslapio turinys",
    admin_landing_desc: "Redaguokite blokus: problema/sprendimas, metrikos ir CTA",
    admin_landing_block1: "Blokas «Problema / Sprendimas»",
    admin_landing_block1_title: "Bloko antraštė",
    admin_landing_block1_problem: "«Problema» antraštė",
    admin_landing_block1_problems: "Problemos punktai (po vieną eilutėje)",
    admin_landing_block1_solution: "«Sprendimas» antraštė",
    admin_landing_block1_solutions: "Sprendimo punktai (po vieną eilutėje)",
    admin_landing_block2: "Metrikos (500+, +280%, 4.9/5)",
    admin_landing_block2_highlight: "Paryškinti",
    admin_landing_block3: "Blokas «Pradėkite uždirbti daugiau»",
    admin_landing_block3_title: "Antraštė",
    admin_landing_block3_text: "Tekstas po antrašte",
    admin_landing_block3_btn: "Telegram mygtuko tekstas",
    admin_landing_block3_url: "Mygtuko nuoroda (URL)",
    admin_hero_block_title: "Hero blokas (pagrindinė antraštė)",
    admin_hero_block_desc: "Redaguokite pagrindinę antraštę ir mygtukus — pakeitimai matomi iš karto",
    admin_hero_title_top: "Antraštės 1 eilutė",
    admin_hero_title_bottom: "Antraštės 2 eilutė",
    admin_hero_subtitle: "Paantraštė",
    admin_hero_shop_btn: "Parduotuvės mygtuko tekstas",
    admin_hero_contact_btn: "Kontaktų mygtuko tekstas",
    admin_hero_contact_url: "Kontaktų mygtuko nuoroda (URL)",

    // MARKDOWN EDITOR
    md_bold: "Pusjuodis",
    md_italic: "Kursyvas",
    md_code: "Kodas",
    md_header: "Antraštė",
    md_list: "Sąrašas",
    md_quote: "Citata",
    md_link: "Nuoroda",
    md_color: "Spalva",
    md_preview: "Peržiūra",
    md_edit: "Redaguoti",
    md_split: "Padalytas vaizdas",
    md_placeholder: "Įveskite aprašymą... Pažymėkite tekstą ir dešiniuoju pelės mygtuku spustelėkite, kad gautumėte parinktis.",
    md_chars: "simbolių",
    md_ctx_format: "Formatavimas",
    md_ctx_headers: "Struktūra",
    md_ctx_color: "Spalvinis paryškinimas",
  },
};

const LANG_KEY = 'ofm_lang_pref';

export const getSystemLanguage = (): LangCode => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem(LANG_KEY);
    const supported = ['en','ru','es','de','fr','pt','zh','ja','ko','ar','it','pl','tr','vi','nl','id','lt'];
    if (saved && supported.includes(saved)) return saved as LangCode;
  }
  return 'en';
};

export const setSystemLanguage = (lang: LangCode) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(LANG_KEY, lang);
  }
};

export function getTranslation(key: string, lang: LangCode, params?: Record<string, string>): string {
  let text = translations[lang]?.[key] || translations['en'][key] || key;
  if (params) {
    Object.keys(params).forEach(param => {
      text = text.replace(`{${param}}`, params[param]);
    });
  }
  return text;
}

export const t = (key: string, params?: Record<string, string>, lang?: LangCode): string => {
  const l = lang ?? getSystemLanguage();
  return getTranslation(key, l, params);
};
